import showToast from "../../Hooks/toast";
import {useConversationJobMutation} from "../../../Store/Builder/messaging.api";
import {addNewChat, setUserData} from "../../../Store/Slice/messagingSlice";
import {useDispatch} from "react-redux";

const useConversationJob = () => {
  const dispatch = useDispatch();
  const [conversationJob] = useConversationJobMutation();
  const create = (id) => {
    const body = {
      id: id,
      body: {}
    }
    conversationJob(body)
      .unwrap()
      .then((res) => {
        dispatch(addNewChat(res))
        dispatch(setUserData(res));
      })
      .catch(() => {
      });
  };

  return {
    create,
  };
};

export default useConversationJob;
